module.exports = __webpack_public_path__ + "static/media/DSC_0026.835f5673.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/scenery/DSC_0026.jpg
// module id = 678
// module chunks = 0